/**
 * Function.prototype.bind ポリフィル
 * 古いブラウザ（IE8等）でbindメソッドを提供
 * thisコンテキストと引数を固定した新しい関数を返す
 */
Function.prototype.bind || (Function.prototype.bind = function (a) {
    if ("function" != typeof this) throw new TypeError(
        "Function.prototype.bind - what is trying to be bound is not callable");
    var b = Array.prototype.slice.call(arguments, 1),
        c = this,
        d = function () { },
        e = function () {
            return c.apply(this instanceof d && a ? this : a, b.concat(Array.prototype.slice.call(arguments)))
        };
    return d.prototype = this.prototype, e.prototype = new d, e
});
